<template>
  <div>
    <v-item-group
      v-model="selected"
      class="d-flex"
      mandatory
      :disabled="disabled"
    >
      <v-item v-slot="{ active, toggle }" :value="1" class="mr-4">
        <v-btn
          class="votes-required-input-btn"
          :color="active ? 'primary' : 'grey lighten-3'"
          tile
          elevation="0"
          :disabled="disabled"
          @click="toggle"
        >
          <v-icon
            class="material-icons-outlined"
            :class="{ active }"
            left
            :color="active ? 'white' : 'grey darken-1'"
          >
            person
          </v-icon>
          <span
            :class="{
              ['grey--text text--darken-1']: !active && !disabled,
            }"
          >
            1 Reviewer
          </span>
        </v-btn>
      </v-item>
      <v-item v-slot="{ active, toggle }" :value="2">
        <v-btn
          class="votes-required-input-btn"
          :color="active ? 'primary' : 'grey lighten-3'"
          tile
          elevation="0"
          :disabled="disabled"
          @click="toggle"
        >
          <v-icon
            class="material-icons-outlined"
            :class="{ active }"
            left
            :color="active ? 'white' : 'grey darken-1'"
          >
            supervisor_account
          </v-icon>
          <span
            :class="{
              ['grey--text text--darken-1']: !active && !disabled,
              ['grey--text text--darken-2 font-weight-bold']:
                active && disabled,
            }"
          >
            2 Reviewers
          </span>
        </v-btn>
      </v-item>
    </v-item-group>
  </div>
</template>

<script>
export default {
  name: 'VotesRequiredInput',
  props: {
    value: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selected: {
      set: function (value) {
        this.$emit('input', value);
      },
      get: function () {
        return this.value;
      },
    },
  },
};
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';
.votes-required-input-btn.v-btn--disabled .v-icon.active {
  color: map-get($grey, 'darken-2') !important;
}
</style>
